import * as React from 'react';
import { useState } from 'react'
import { StarIcon } from '@heroicons/react/20/solid'
import Modal from "react-modal";
import { decompressToBase64, formatter } from "../../utils/common.js";
import { AddToCart, GetCount } from "../ShoppingCart/CartHandler.js";
import parse from "html-react-parser";
import "./ProductDetails.css"
import { useEffect } from "react";
import { Button, Container, Grid, Rating } from "@mui/material";
import Cart from "../ShoppingCart/Cart.js";
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

import {
  ListDivider, Typography, Switch, Radio,
  RadioGroup, Box, List, ListItem
} from '@mui/joy';



const reviews = { href: '#', average: 4, totalCount: 117 }

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}



// Modal.setAppElement('#root');
function ItemModal({ item, onRequestClose, cartCount, setCartCount, selectLocation }) {

  const addItem = (item) => {
    AddToCart(item.itemDescription, item.images, item.itemNumber, item.price, newQuantity);
    setCartCount(GetCount());
    onRequestClose();
  };

  const [orientation, setOrientation] = React.useState('horizontal');


  const afterOpenModal = () => {
    // references are now sync'd and can be accessed.
  };

  const handleChange = (event, newValue) => {
    alert(`You chose "${newValue}"`);
  };
  // const close = () =>{onRequestClose()};

  // const closeModal = () => {
  //     close();
  // };

  const customStyles = {
    content: {
      //top: '50%',
      //left: '50%',
      //right: 'auto',
      //bottom: 'auto',
      //marginRight: '-50%',
      //transform: 'translate(-50%, -50%)',
    },
  };
  const [newQuantity, setNewQuantity] = useState(1);
  const [quantity, setQuantity] = useState(1);
  const [subtitle, setSubtitle] = useState();

  function unflatten() {
    return (
      <div className="metabox">
        {[...Array(20).keys()].map((i) =>
          item[`metadata${i + 1}Active`] === true ? (
            <p key={`metadata${i + 1}Name`}>
              <label className="metadata">{item[`metadata${i + 1}Name`]}</label>
              : <label className="metadata">{item[`metadata${i + 1}`]}</label>
            </p>
          ) : null
        )}
      </div>
    );
  }
  const [activeImg, setActiveImg] = useState(item.images[0]);






  return (
    <Modal
      isOpen
      onAfterOpen={afterOpenModal}
    >
      <Container container className="p-details-modal bg-white" >

        <div className="">
          <nav aria-label="Breadcrumb">
            <ol role="list" className="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
              <li className="text-sm">
                <a aria-current="page" className="font-medium text-gray-500 hover:text-gray-600">
                  {"category"}
                </a>
              </li>
            </ol>
          </nav>

          {/* Image gallery */}
          <div className="mx-auto mt-3 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
            <img

              className='bg-img' src={
                "data:image/png;base64," +
                decompressToBase64(activeImg?.compressedImageData)
              } alt='' />
            <div className="mx-auto  lg:grid pt-3  lg:grid-cols-3 lg:gap-x-8 lg:px-8" id='sm-img-group'>
              {!!item.images &&
                item.images.map((image, index) => (
                  <div key={image.index}>
                    <img
                      onClick={() => setActiveImg(image)}
                      className='sm-img'
                      src={
                        "data:image/png;base64," +
                        decompressToBase64(image.compressedImageData)
                      }
                    />
                  </div>

                ))}
            </div>
          </div>


          {/* Product info */}
          <div className="mx-auto max-w-2xl px-4 pb-16 pt-4 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">
            <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
              <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{item.itemDescription}</h1>
            </div>

            {/* Options */}
            <div className="mt-4 lg:row-span-3 lg:mt-0">

              {/* Reviews */}
              <div className="mt-6">
                <h3 className="sr-only">Reviews</h3>
                <div className="flex items-center">
                  <div className="flex items-center">
                    {[0, 1, 2, 3, 4].map((rating) => (
                      <StarIcon
                        key={rating}
                        className={classNames(
                          reviews.average > rating ? 'text-gray-900' : 'text-gray-200',
                          'h-5 w-5 flex-shrink-0',
                        )}
                        aria-hidden="true"
                      />
                    ))}
                  </div>
                  <p className="sr-only">{reviews.average} out of 5 stars</p>
                  <a href={reviews.href} className="ml-3 text-sm font-medium text-indigo-600 hover:text-indigo-500">
                    {reviews.totalCount} reviews
                  </a>
                </div>
              </div>
              <div className='lg:flex-row'>
              <div className='lo-label mb-[2rem]'>Current location: </div>
              <div className='lo-data'>{selectLocation}</div>

              </div>
              <p className="text-1xl tracking-tight text-gray-900 mt-3" >Item Number:  {item.itemNumber}</p>
              <p className="text-3xl tracking-tight text-gray-900">{formatter.format(item.price)}</p>
              <div className="flex-row item-amount ">
                <p className="amount-text">Item amount:</p>
                <input
                  className="quantity-input"
                  type="number"
                  placeholder='1'
                  min={1}
                  step={1}
                  onChange={(e) => setNewQuantity(parseInt(e.target.value, 10))}
                />
              </div>


              <div className="mt-10">
                {/* Colors */}
                {/* <div>
                <h3 className="text-sm font-medium text-gray-900">Color</h3>

                <fieldset aria-label="Choose a color" className="mt-4">
                  <RadioGroup value={selectedColor} onChange={setSelectedColor} className="flex items-center space-x-3">
                    {product.colors.map((color) => (
                      <Radio
                        key={color.name}
                        value={color}
                        aria-label={color.name}
                        className={({ focus, checked }) =>
                          classNames(
                            color.selectedClass,
                            focus && checked ? 'ring ring-offset-1' : '',
                            !focus && checked ? 'ring-2' : '',
                            'relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-none',
                          )
                        }
                      >
                        <span
                          aria-hidden="true"
                          className={classNames(
                            color.class,
                            'h-8 w-8 rounded-full border border-black border-opacity-10',
                          )}
                        />
                      </Radio>
                    ))}
                  </RadioGroup>
                </fieldset>
              </div> */}

                {/* Sizes */}
                <div className="unflatten">{unflatten(item)}</div>

              </div>
            </div>

            <div className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pb-16 lg:pr-8 lg:pt-6">
              {/* Description and details */}
              <div>
                <h3 className="sr-only">Description</h3>

                <div className="space-y-6">
                  <p className="text-base text-gray-900">{item.extendedDesc != null
                    ? parse(item.extendedDesc)
                    : "No Description"}</p>
                </div>
              </div>
              <div className="mt-10">
                <div className="mt-4 space-y-6">
                  <button
                    onClick={() => addItem(item)}
                    type="submit"
                    className="mt-10 flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    Add to bag
                  </button>
                  <button
                    type="submit"
                    onClick={onRequestClose}
                    className="mt-2 flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Container>
    </Modal>

  )
}
export default ItemModal;